/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/application_flow_update';
import '../../models/application_flow';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "UpdateApplicationFlowRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "applicationFlow": {
                        "type": ".squareup.sfs.external.models.ApplicationFlowUpdate",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateApplicationFlowResponse": {
                    "fields": {
                      "applicationFlow": {
                        "type": ".squareup.sfs.external.models.ApplicationFlow",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.UpdateApplicationFlowRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.UpdateApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateApplicationFlowRequest @ squareup/sfs/external/services/application_flow/update_application_flow.proto at 9:1
 */
export const UpdateApplicationFlowRequest = $root.lookupType('squareup.sfs.external.service.UpdateApplicationFlowRequest');
fixType(UpdateApplicationFlowRequest);
Builder.createAndAttachToType(UpdateApplicationFlowRequest);
/**
 * SOURCE UpdateApplicationFlowResponse @ squareup/sfs/external/services/application_flow/update_application_flow.proto at 21:1
 */
export const UpdateApplicationFlowResponse = $root.lookupType('squareup.sfs.external.service.UpdateApplicationFlowResponse');
fixType(UpdateApplicationFlowResponse);
Builder.createAndAttachToType(UpdateApplicationFlowResponse);